import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import Select from '../../UI/Select/Select';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import { useDispatch } from 'react-redux';
import { updateAddress } from '../../../http/user';
import { useTranslation } from 'react-i18next';
import countries from '../../../constants/countries';
import styles from '../Signup/Signup.module.scss';

const EditAddressModal = ({ open, onClose, user }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values) => {
    setSubmitting(true);
    if (!values.flat) {
      delete values.flat;
      user.flat = null;
    }
    
    try {
      await dispatch(updateAddress(values));
      message.success(t('modals.address.success'));
      onClose();
    } catch (error) {
      const status = error?.response?.status;
      if (status === 422 && error.response.data?.errors) {
        const fieldErrors = error.response.data.errors;
        form.setFields(
          Object.entries(fieldErrors).map(([name, errors]) => ({
            name,
            errors: Array.isArray(errors) ? errors : [String(errors)],
          }))
        );
        message.error(t('modals.address.invalidData'));
      } else if (status === 400) {
        message.error(t('modals.address.badRequest'));
      } else {
        message.error(error?.message || t('modals.address.error'));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      className={styles.responsiveModal}
      style={{ maxWidth: '90vw', width: '100%' }}
    >
      <div className={styles.modalContent}>
        <h2 style={{ textAlign: 'center' }}>{t('modals.address.title')}</h2>

        <Form
          form={form}
          layout="vertical"
          initialValues={{
            country: user.country || undefined,
            city: user.city,
            street: user.street,
            house: user.house,
            flat: user.flat,
            zip: user.zip,
          }}
          onFinish={handleFinish}
          style={{ marginTop: 30, width: '100%' }}
        >
          <Form.Item
            name="country"
            label={t('input.country')}
            rules={[{ required: true, message: t('schema.required') }]}
          >
          <Select
            placeholder={t('input.country')}
            options={Object.entries(countries).map(([code, name]) => ({
              value: code,
              label: name,
            }))}
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

          <div className={styles.flexGroup}>
            <Form.Item
              name="city"
              label={t('input.city')}
              rules={[{ required: true, message: t('schema.required') }]}
              style={{ flex: 1 }}
            >
              <Input placeholder={t('input.city')} />
            </Form.Item>

            <Form.Item
              name="zip"
              label={t('input.zip')}
              rules={[{ required: true, message: t('schema.required') }]}
              style={{ flex: 1 }}
            >
              <Input placeholder={t('input.zip')} />
            </Form.Item>
          </div>

          <div className={styles.flexGroup}>
            <Form.Item
              name="street"
              label={t('input.street')}
              rules={[{ required: true, message: t('schema.required') }]}
              style={{ flex: 1 }}
            >
              <Input placeholder={t('input.street')} />
            </Form.Item>

            <Form.Item
              name="house"
              label={t('input.house')}
              rules={[{ required: true, message: t('schema.required') }]}
              style={{ flex: 1 }}
            >
              <Input placeholder={t('input.house')} />
            </Form.Item>
          </div>

          <Form.Item name="flat" label={t('input.flat')}>
            <Input placeholder={t('input.flat')} />
          </Form.Item>

          <Button
            wide
            disabled={submitting}
            onClick={form.submit}
            style={{ marginTop: 10 }}
          >
            {t('modals.address.save')}
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default EditAddressModal;
